import { action } from 'easy-peasy';
import { IActionSetIsMfaRequired } from '../types';

const setIsMfaRequired: IActionSetIsMfaRequired = action((state, data) => {
  state.isMfaRequired = true;
  state.mfaRequired = data;
});

export default setIsMfaRequired;
